'use strict';

const React                    = require('react');
const PropTypes = require('prop-types');
const {trackPinterestClick}    = require('newPdp/actions/pdpTrackingActions.es');
const TRACKING_SUFFIX = 'zoom modal';

const Pinterest = require('global/components/Pinterest/Icon');
const pinterestActions = require('global/actions/pinterestActions');

class PinterestButton extends Pinterest {

    constructor(props) {
        super(props);
        this._handlePinterestChange = this._handlePinterestChange.bind(this);

        this.state = {
            media: this.props.media
        };
    }

    componentDidMount() {
        const {model} = this.props;
        if (model) {
            model.on('change', this._handlePinterestChange);
        }
    }

    componentWillUnmount() {
        this.props.model.off('change');
    }

    _handlePinterestChange(model) {
        const media = model.getSelectedImage();
        this.setState({media});
    }

    pin() {
        const {url, description} = this.props;
        const {media} = this.state;
        const pinterestWindow = this.openWindow();
        this.context.executeAction(pinterestActions.pin, {pinterestWindow, url, media, description});
        this.context.executeAction(trackPinterestClick, {suffix: TRACKING_SUFFIX});
    }

    render() {
        const divStyle = {
            cursor: 'pointer'
        };

        return (
            <div style={divStyle}
                data-tn='pinterest'
                data-pin-do={this.props.pinDo}
                data-pin-config={this.props.pinConfig}
                data-pin-color={this.props.pinColor}
                data-pin-height={this.props.pinHeight}
                onClick={this.pin}>
                <img src={this.props.buttonSrc} />
            </div>
        );
    }

}

PinterestButton.propTypes = Object.assign({}, Pinterest.propTypes, {
    buttonSrc: PropTypes.string,
    pinDo: PropTypes.string,
    pinConfig: PropTypes.string,
    pinColor: PropTypes.string,
    pinHeight: PropTypes.string
});

PinterestButton.defaultProps = Object.assign({}, Pinterest.defaultProps, {
    buttonSrc: '//assets.pinterest.com/images/pidgets/pinit_fg_en_rect_white_28.png',
    pinDo: 'buttonPin',
    pinConfig: 'above',
    pinColor: 'white',
    pinHeight: '28'
});

module.exports = PinterestButton;



// WEBPACK FOOTER //
// ./assets/js/social/components/PinterestButton.jsx